import React, { useEffect, useState } from "react";
import Navbar from "../../AcuvisorCustomerApp/HealthInsurance/Components/Navbar/Navbar";
import axiosInstance from "../../Utilities/djangoAxiosInstance";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loading from "../../AcuvisorCustomerApp/HealthInsurance/Components/Loading";
import { PAYMENT_OPTIONS_PAGE_ROUTE } from "../../HealthInsuranceNew/routes";
function OtpPage() {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(["", "", "", ""]);
  const concatenatedOtp = otp.join("");
  const [errorMessage, setErrorMessage] = useState("");
  const { productId } = useParams();
  const [transferData, setTransferData] = useState();
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [alertMessage, setAlertMessage] = useState();
  const [remainingTime, setRemainingTime] = useState(120); // Initial remaining time in seconds
  const [canResend, setCanResend] = useState(true);
  const [CISError, setCISError] = useState(null);
  console.log("proo", productId);

  //this Api is for transferData
  useEffect(() => {
    console.log("productId", productId);
    axiosInstance
      .get(`api/health/transfer-data/${productId}`, {
        params: {
          source: "posp",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          console.log("transferData Response in OTP", response);
          setTransferData(response);
        }
      })
      .catch((e) => {
        alert(e);
      });
  }, []);

  //this Api is for CIS document
  useEffect(() => {
    axiosInstance
      .post(`api/health/cis-doc/${productId}`)
      .then((response) => {
        if (response.status === 200) {
          console.log("CIS response", response);
          setLoading(false); // only set loading false when success
          setCISError(null)
          // axiosInstance.post(`api/send-email/${productId}`)
          //     .then((response) => {
          //         if (response.status === 200) {
          //             setSuccessMessage('OTP sent successfully');
          //             console.log("send-email", response);
          //             toast("An OTP has been sent on your email")
          //         }
          //     })
          //     .catch((e) => {
          //         alert(e);
          //     });
        }
      })
      .catch((e) => {
        alert(e);
        // If any error then display to user
        handleDisplayError(e);
      });
    // .finally(() => {
    //   setLoading(false);
    // });
  }, []);

  //this Api is for Send Email
  // useEffect(() => {
  //     axiosInstance.post(`api/send-email/${productId}`)
  //         .then((response) => {
  //             if (response.status === 200) {
  //                 console.log("send-email", response);
  //             }
  //         })
  //         .catch((e) => {
  //             alert(e);
  //         });
  // }, [])

  const handleBack = () => {
    // Navigate back one step
    navigate(-1);
  };

  const handleInputChange = (e, index) => {
    const value = e.target.value;
    const newOtp = [...otp];

    if (/^\d$/.test(value) || value.length === 0) {
      if (value.length === 1) {
        // Update the current digit
        newOtp[index] = value;

        if (index < otp.length - 1) {
          // Move focus to the next input
          document.getElementById(`otpInput-${index + 1}`).focus();
        }
      } else if (value.length === 0) {
        // Clear the current digit
        newOtp[index] = value;

        // Move focus to the previous input if not the first input
        if (index > 0) {
          document.getElementById(`otpInput-${index - 1}`).focus();
        }
      }

      // Update the state
      setOtp(newOtp);
    }
  };

  const sendOtp = () => {
    axiosInstance
      .post(`api/send-email/${productId}`)
      .then((response) => {
        if (response.status === 200) {
          setSuccessMessage("OTP sent successfully");
          console.log("send-email", response);
          toast("An OTP has been sent on your email");
          setSuccessMessage(true);
        }
      })
      .catch((e) => {
        alert(e);
      });

    setRemainingTime(120);
    setCanResend(false);
  };

  // timer
  useEffect(() => {
    let timer;

    // Update the remaining time every second
    if (remainingTime > 0 && !canResend) {
      timer = setInterval(() => {
        setRemainingTime((prevTime) => prevTime - 1);
      }, 1000);
    } else {
      // Enable the resend button when the time is up
      setCanResend(true);
    }

    // Clear the timer when the component is unmounted or remainingTime reaches 0
    return () => clearInterval(timer);
  }, [remainingTime, canResend]);

  const handleSubmit = () => {
    axiosInstance
      .post(`api/verify-otp/${productId}?otp=${concatenatedOtp}`, {
        params: {
          otp: otp,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          console.log("transferData Response in OTP", response);

          toast(response?.data?.message);
          if (response?.data?.status === 400) {
            setAlertMessage(response?.data?.message);
          }
          if (response.data.status === 200) {
            navigate(`${PAYMENT_OPTIONS_PAGE_ROUTE}/${productId}`);
          }
        }
      })
      .catch((e) => {
        alert(e);
      });

    // Validate the OTP (For example, checking if all digits are filled)
    const isOtpValid = otp.every((digit) => /^\d$/.test(digit));

    if (isOtpValid) {
      // Your logic for handling a valid OTP submission
      setErrorMessage("");
      console.log("OTP submitted:", otp.join(""));
    } else {
      // Display an error message
      setErrorMessage("Please fill in all OTP digits.");
    }
  };

  const handleDisplayError = (error) => {
    console.log("Error while hitting api/health/cis-doc", error);

    console.log("error object errors:", error?.response);
    const errData = error?.response?.data;
    if (!errData) return;

    const errReasonMessage =
      errData?.Message ??
      errData?.Error ??
      "Something unknown happend while generating document";

    setCISError(errReasonMessage); // not used now
  };
  if (CISError)
    return (
      <div>
        <Navbar />
        <section className="text-gray-600 body-font">
          <div className="container px-5 py-24 mx-auto">
            <div className="xl:w-1/2 lg:w-3/4 w-full mx-auto text-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                className="inline-block w-8 h-8 text-gray-400 mb-8"
                viewBox="0 0 975.036 975.036"
              >
                <path d="M925.036 57.197h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.399 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l36 76c11.6 24.399 40.3 35.1 65.1 24.399 66.2-28.6 122.101-64.8 167.7-108.8 55.601-53.7 93.7-114.3 114.3-181.9 20.601-67.6 30.9-159.8 30.9-276.8v-239c0-27.599-22.401-50-50-50zM106.036 913.497c65.4-28.5 121-64.699 166.9-108.6 56.1-53.7 94.4-114.1 115-181.2 20.6-67.1 30.899-159.6 30.899-277.5v-239c0-27.6-22.399-50-50-50h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.4 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l35.9 75.8c11.601 24.399 40.501 35.2 65.301 24.399z" />
              </svg>
              <h2 className="text-red-500 font-medium title-font tracking-wider text-sm">
                ERROR 
              </h2>
              <p className="leading-relaxed text-lg">
                Unable to Generate CIS Document
              </p>
              <p>😞</p>
              <span className="inline-block h-1 w-10 rounded bg-red-500 mt-8 mb-6" />
              {/* <p className="text-gray-500">{CISError}</p> */}
            </div>
          </div>
        </section>
      </div>
    );
  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div>
          <Navbar />
          <div className="flex lg:mx-auto my-10 shadow-xl bg-slate-200 max-w-full lg:w-2/3 sm:w-full h-fit">
            <div className="hidden sm:hidden lg:flex lg:w-2/4 max-h-fit shadow-xl ">
              {/* <img src='./images/otp2.jpg' className=" p-1" alt="logo" /> */}
              <img src="/images/otp2.jpg" className="p-1" alt="otpimg" />
            </div>

            <div className="flex justify-center form-container lg:w-2/4 pb-0 sm:w-4/5  ">
              <div className="p-6 text-base text-gray-700 sm:text-lg py-14">
                {successMessage ? (
                  <div className="">
                    <h4 className="text-center pt-4 text-3xl font-medium text-gray-800 font-sans">
                      Enter the OTP sent to your Email.
                    </h4>

                    <div className="flex space-x-4 justify-center items-center pt-6">
                      {otp.map((digit, index) => (
                        <input
                          key={index}
                          id={`otpInput-${index}`}
                          type="text"
                          value={digit}
                          maxLength="1"
                          onChange={(e) => handleInputChange(e, index)}
                          autoFocus={index === 0}
                          className="w-12 h-12 border border-gray-300 rounded-md text-center text-lg focus:outline-none"
                        />
                      ))}
                    </div>
                    <span className="text-red-500 flex space-x-4 justify-center items-center pt-6">
                      {alertMessage}
                    </span>

                    {/* <div className='text-center text-sm mt-3'>
                                            Remaining time: {remainingTime} seconds
                                        </div> */}

                    <div className="text-center text-sm mt-3">
                      {!canResend ? (
                        <p>
                          Didn't get the code? Resend after {remainingTime}{" "}
                          seconds.
                        </p>
                      ) : (
                        <p>
                          Didn't get the code?{" "}
                          <button
                            onClick={sendOtp}
                            className="text-blue-500 no-underline"
                          >
                            Resend
                          </button>
                        </p>
                      )}
                    </div>

                    <div className="flex space-x-4 justify-center items-center">
                      {errorMessage && (
                        <p className="text-red-500 mt-2">{errorMessage}</p>
                      )}
                    </div>

                    <div className="flex justify-center">
                      <button
                        onClick={handleSubmit}
                        className="mt-14 w-full bg-blue-500 text-white px-4 py-2 rounded-3xl"
                      >
                        Submit OTP
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="">
                    <h4 className="text-center pt-4 text-3xl font-medium text-gray-800 font-sans">
                      We have sent an OTP to this Email.
                    </h4>

                    <div className="mt-10 pt-1 pb-0 bg-white flex justify-center items-center border rounded-lg ">
                      <p className="text-lg font-semibold text-gray-800">
                        {transferData?.data?.email_id}
                      </p>
                    </div>

                    <div className="mt-4">
                      <button
                        onClick={sendOtp}
                        className="w-full bg-blue-500 text-white px-4 py-2 rounded-3xl"
                      >
                        Send Otp
                      </button>
                    </div>

                    <div className="mt-4">
                      <button
                        onClick={handleBack}
                        className="w-full bg-white text-blue-500 px-4 py-2 rounded-3xl border-2 border-blue-500"
                      >
                        Back
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default OtpPage;
